/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { apiFetch } from '../../../shared/apiClient';
import Team from '../teams/types/Team';
import Season from './types/Season';
import SeasonSummary from './types/SeasonSummary';

export async function addSeason(
	title: string,
	betCountPerMatchDay: number,
	defaultBetSize: number,
	startDate: string,
	endDate: string
): Promise<Season> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/seasons`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = '/api/seasons';
	}
	const result = await apiFetch(`${url}`, {
		method: 'POST',
		body: JSON.stringify({ title, betCountPerMatchDay, defaultBetSize, startDate, endDate }),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getSeasons(): Promise<{ seasons: Season[] }> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/seasons`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = '/api/seasons';
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getSeasonSummaries(): Promise<{ seasons: SeasonSummary[] }> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/seasons/summaries`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = '/api/seasons/summaries';
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getSeasonStatusList(): Promise<string[]> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/seasons/statuses`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = '/api/seasons/statuses';
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function getLeagueCodeList(): Promise<string[]> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/seasons/leagues/codes`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = '/api/seasons/leagues/codes';
	}
	const result = await apiFetch(`${url}`);
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function changeSeasonStatus(id: string, status: string): Promise<Season> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/seasons/${id}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/seasons/${id}`;
	}
	const result = await apiFetch(`${url}`, {
		method: 'PATCH',
		body: JSON.stringify(status),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

/** Параллельные вызовы делят один HTTP-запрос (App + страницы часто стартуют вместе). */
let activeSeasonInflight: Promise<Season> | null = null;

export async function getActiveSeason(): Promise<Season> {
	if (activeSeasonInflight) {
		return activeSeasonInflight;
	}
	activeSeasonInflight = (async (): Promise<Season> => {
		let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/seasons/active`;
		if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
			url = '/api/seasons/active';
		}
		const result = await apiFetch(`${url}`);

		if (result.status >= 400) {
			const { message }: { message: string } = await result.json();
			throw new Error(message);
		}
		return result.json();
	})().finally(() => {
		activeSeasonInflight = null;
	});
	return activeSeasonInflight;
}

let activeSeasonIdInflight: Promise<{ value: string }> | null = null;

export async function getActiveSeasonId(): Promise<{ value: string }> {
	if (activeSeasonIdInflight) {
		return activeSeasonIdInflight;
	}
	activeSeasonIdInflight = (async (): Promise<{ value: string }> => {
		let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/seasons/active/id`;
		if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
			url = '/api/seasons/active/id';
		}
		const result = await apiFetch(`${url}`);

		if (result.status >= 400) {
			const { message }: { message: string } = await result.json();
			throw new Error(message);
		}
		return result.json();
	})().finally(() => {
		activeSeasonIdInflight = null;
	});
	return activeSeasonIdInflight;
}

export async function getScheduledSeason(): Promise<Season> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/seasons/scheduled`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = '/api/seasons/scheduled';
	}
	const result = await apiFetch(`${url}`);

	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function registrationInSeason(seasonId: string): Promise<Season> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER}/api/seasons/registration/${seasonId}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/seasons/registration/${seasonId}`;
	}
	const result = await apiFetch(`${url}`, {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
	});
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

// export async function getLeaguesBySeason(seasonId: string): Promise<Season> {
//   let url = `${import.meta.env.VITE_PRODUCT_SERVER}/login`;
//   if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
//     url = '/login';
//   }
//   const result = await apiFetch(`/api/seasons/${seasonId}/leagues`);
//   if (result.status >= 400) {
//     const { message }: { message: string } = await result.json();
//     throw new Error(message);
//   }
//   return result.json();
// }

export async function addLeagueToSeason(
	seasonId: string,
	leagueCode: string,
	tournamentFormatId?: string
): Promise<Season> {
	let url = `${import.meta.env.VITE_PRODUCT_SERVER || ''}/api/seasons/${seasonId}/leagues`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/seasons/${seasonId}/leagues`;
	}
	const body: { leagueCode: string; tournamentFormatId?: string } = { leagueCode };
	if (tournamentFormatId) {
		body.tournamentFormatId = tournamentFormatId;
	}
	const result = await apiFetch(`${url}`, {
		method: 'POST',
		body: JSON.stringify(body),
		headers: {
			'Content-Type': 'application/json',
		},
	});
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function addTeamToLeagueInSeason(
	seasonId: string,
	leagueId: string,
	teamId: string
): Promise<Team> {
	let url = `${
		import.meta.env.VITE_PRODUCT_SERVER || ''
	}/api/seasons/${seasonId}/leagues/${leagueId}/teams/${teamId}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/seasons/${seasonId}/leagues/${leagueId}/teams/${teamId}`;
	}
	const result = await apiFetch(`${url}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
	});
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function removeTeamFromLeagueInSeason(
	seasonId: string,
	leagueId: string,
	teamId: string
): Promise<Team> {
	let url = `${
		import.meta.env.VITE_PRODUCT_SERVER || ''
	}/api/seasons/${seasonId}/leagues/${leagueId}/teams/${teamId}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/seasons/${seasonId}/leagues/${leagueId}/teams/${teamId}`;
	}
	const result = await apiFetch(url, { method: 'DELETE' });
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}

export async function removeLeagueFromSeason(seasonId: string, leagueId: string): Promise<Season> {
	let url = `${
		import.meta.env.VITE_PRODUCT_SERVER || ''
	}/api/seasons/${seasonId}/leagues/${leagueId}`;
	if (import.meta.env.VITE_PRODUCT_SERVER === 'localhost') {
		url = `/api/seasons/${seasonId}/leagues/${leagueId}`;
	}
	const result = await apiFetch(url, { method: 'DELETE' });
	if (result.status >= 400) {
		const { message }: { message: string } = await result.json();
		throw new Error(message);
	}
	return result.json();
}
